export default basket_items => {
  if(!basket_items.length) return basket_items

  return basket_items.reduce((basket, current) => {
    const is_item_in_basket = basket.some(({ variant_id, id }) => (variant_id + id) === (current.variant_id + current.id))
  
    return is_item_in_basket ? basket : [...basket, current]
  }, [])
}